import React from 'react';
import { AlertTriangle } from 'react-feather';
import Page, { PageContentBodyGrid } from './Shared/Page/Page';
import PageGridItem from './Shared/Page/PageGridItem';
import "./ErrorPage.scss";

const ErrorPage = ({errorHeader, errorMessage}) => {
	return (
		<Page noBanner>
			<PageContentBodyGrid id="error-message">
				<PageGridItem colSpan="12">
					<div className="error-message-wrapper">
						<div className="error-header">
							<AlertTriangle />
							<h1>{errorHeader ? errorHeader : "404"}</h1>
						</div>
						<div className="error-message">
							<p>{errorMessage ? errorMessage : "Sorry, but it looks like this page doesn’t exist"}</p>
						</div>
					</div>
				</PageGridItem>
			</PageContentBodyGrid>
		</Page>
	);
}
export default ErrorPage;